import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import { TierlistTable } from "./TierlistTable";
import { CURRENT_PATCH } from "api/apiHelpers";
import "../../../stylesheets/components/TierlistStyles.scss";
import TierlistNavs from "./TierlistNavs";
import TierlistFilterManager from "./TierlistFilterManager";

const TierlistPageContainer = () => {
  const metaTitle = "Deadlock Tier List - Highest Winrate Heroes For This Patch";
  const metaDescription = `The only Deadlock tier list you need for the newest patch. Always up-to-date, U.GG takes a data science approach to the best Deadlock champions.`;
  const [heroFilterText, setHeroFilterText] = useState("");

  return (
    <div className="flex mx-auto w-full max-md:w-full">
      <div className="deadlock-page-container content-side-padding tierlist">
        <Helmet>
          <title>{metaTitle}</title>
          <meta name="description" content={metaDescription} />
          <link rel="canonical" href="https://u.gg/deadlock/tier-list" />
        </Helmet>
        <div className="tierlist-container">
          <div className="tierlist-header">
            <div className="tierlist-title-container">
              <h1 className="tierlist-title">
                <span>Deadlock Tier List</span>
                <span className="tierlist-title-sub">for All Heroes</span>
              </h1>
              {/* <div className="patch max-[899px]:!hidden ">Patch {CURRENT_PATCH}</div> */}
            </div>
            <span className="tierlist-subtitle">
              The only Deadlock Tier list you need for the newest patch. Always up-to-date, U.GG takes a data science approach to
              the best champions on every role.
            </span>
            <TierlistNavs tierlistType="all" />
          </div>
          <div className="tierlist-filters">
            <TierlistFilterManager heroFilterText={heroFilterText} setHeroFilterText={setHeroFilterText} />
          </div>
          <div className="min-[1140px]:w-[1014px]">
            <TierlistTable heroFilterText={heroFilterText} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TierlistPageContainer;
